import React from "react";
import "./Disclaimer.css";

const Disclaimer = () => {
  return (
    <div className="disclaimer-container">
      <div className="disclaimer-header">
        <h1>Disclaimer</h1>
        <p>Disclaimer For Satta Wala Online</p>
      </div>

      <div className="disclaimer-content">
        <section className="disclaimer-section">
          <h2>Read Our Website Disclaimer Here:</h2>
          <p>
            Do you have any query related to our website and{" "}
            <strong>Satta King Result</strong>?  
            You can contact us at: <br />
            📞 <strong>3201456987</strong> <br />
            📧 <strong>example@gmail.com</strong>
          </p>
        </section>

        <section className="disclaimer-section">
          <h2>Disclaimers For satta-wala-online</h2>
          <p>
            All the details and information you are reading are provided only
            for the purpose of giving people correct information and helping
            them. We have shared all reports and internal as well as external
            linking on our website.  
          </p>
          <p>
            Our aim is to make sure that people can easily find the details they
            are looking for.
          </p>
        </section>

        <section className="disclaimer-section">
          <h2>Consent</h2>
          <p>
            By reaching our website and reading the information provided here,
            you agree to our <strong>Privacy Policy</strong> and{" "}
            <strong>Terms & Conditions</strong>.
          </p>
        </section>

        <section className="disclaimer-section">
          <h2>Update</h2>
          <p>
            Any changes made by our team will be updated on this page from time
            to time. Please review it regularly to stay informed.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Disclaimer;
